module.exports = require("cookie");